import Avatar1 from '../../../../assets/avatars/1.svg';
import Avatar2 from '../../../../assets/avatars/2.svg';
import Avatar3 from '../../../../assets/avatars/3.svg';
import Avatar4 from '../../../../assets/avatars/4.svg';
import Avatar5 from '../../../../assets/avatars/5.svg';
import Avatar6 from '../../../../assets/avatars/6.svg';
import Avatar7 from '../../../../assets/avatars/7.svg';
import Avatar8 from '../../../../assets/avatars/8.svg';
import Avatar9 from '../../../../assets/avatars/9.svg';
import Avatar10 from '../../../../assets/avatars/10.svg';
import Avatar11 from '../../../../assets/avatars/11.svg';
import Avatar12 from '../../../../assets/avatars/12.svg';

interface IAvatarUser {
  id: number;
  avatar: string;
}

export const getAvatar = (avatarId: number) => {
  switch (avatarId) {
    case 1:
      return Avatar1;
    case 2:
      return Avatar2;
    case 3:
      return Avatar3;
    case 4:
      return Avatar4;
    case 5:
      return Avatar5;
    case 6:
      return Avatar6;
    case 7:
      return Avatar7;
    case 8:
      return Avatar8;
    case 9:
      return Avatar9;
    case 10:
      return Avatar10;
    case 11:
      return Avatar11;
    case 12:
      return Avatar12;
    default:
      return Avatar1;
  }
};

export const avatarsList: IAvatarUser[] = [
  {
    id: 1,
    avatar: getAvatar(1),
  },
  {
    id: 2,
    avatar: getAvatar(2),
  },
  {
    id: 3,
    avatar: getAvatar(3),
  },
  {
    id: 4,
    avatar: getAvatar(4),
  },
  {
    id: 5,
    avatar: getAvatar(5),
  },
  {
    id: 6,
    avatar: getAvatar(6),
  },
  {
    id: 7,
    avatar: getAvatar(7),
  },
  {
    id: 8,
    avatar: getAvatar(8),
  },
  {
    id: 9,
    avatar: getAvatar(9),
  },
  {
    id: 10,
    avatar: getAvatar(10),
  },
  {
    id: 11,
    avatar: getAvatar(11),
  },
  {
    id: 12,
    avatar: getAvatar(12),
  },
];

const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};
/* eslint-disable */
export const stringAvatar = (name: string) => {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
};
